<div ngbDropdown #myDrop="ngbDropdown" placement="bottom-right" autoClose="outside" class="kt-header__topbar-item">
    <div ngbDropdownToggle class="kt-header__topbar-wrapper">
        <span class="kt-header__topbar-icon"
            [ngClass]="{'kt-pulse kt-pulse--brand': pulse, 'kt-pulse--light' : pulseLight, 'kt-header__topbar-icon--success' : iconType === 'success'	}">
            <!-- <i *ngIf="!useSVG" [ngClass]="icon" ></i> -->
            <span class="material-icons yellow-color"> notifications </span>
            <!-- <span *ngIf="useSVG" class="kt-svg-icon" [ngClass]="{'kt-svg-icon--success' : iconType === 'success'}"
                [inlineSVG]="icon"></span> -->
            <span class="kt-pulse__ring" [hidden]="!pulse"></span>
        </span>
        <span class="kt-badge kt-badge--dot kt-badge--notify kt-badge--sm kt-badge--brand" [hidden]="!dot"></span>
    </div>

    <div ngbDropdownMenu 
        class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
        <form>
            <!--begin: Head -->
            <div class="kt-head kt-head--skin-{{skin}} kt-head--fit-x kt-head--fit-b"
                [ngStyle]="{'background-image': backGroundStyle() }">
                <a class="readAll" (click)="clearALL()">Read All</a>
                <h3 style="color: black;" class="kt-head__title p-4">
                    My Notifications
                </h3>

            </div>
            <!--end: Head -->

            <div
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="500"
            (scrolled)="onScroll($event)"
            [scrollWindow]="false" [perfectScrollbar]="{wheelPropagation: false}" 
                [ngStyle]="{'max-height': '40vh', 'position': 'relative','overflow-y': 'scroll'}"
                class="kt-notification kt-margin-t-10 kt-margin-b-10" > 
                <div [ngStyle]="{'background':!item.isRead?'#3287a80f':'','border-bottom': !item.isRead?'3px solid rgba(50, 135, 168, 0.07)':''}"  href="javascript:;" [routerLink]="['orders/order-details/'+ item.orderId]" (click)="ReadNotification(item.id);myDrop.close();"  class="kt-notification__item"  *ngFor="let item of userNotificationsList">

                    <div  class="kt-notification__item-details">
                        <div class="kt-notification__item-title">
                            <h5>{{item.titleEn}}</h5>
                        </div>
                        <div class="kt-notification__item-time">
                            {{item.bodyEn}}
                        </div>
                        <div class="kt-notification__item-time">
                            {{item.createdOn | dateTimeAgoPipe }}
                            <!-- 2 hrs ago -->
                        </div>
                    </div>
                </div>

                <div class="ps__rail-x" style="left: 0px; bottom: 0px;">
                    <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
                </div>
                <div class="ps__rail-y" style="top: 0px; right: 0px;">
                    <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
                </div>
            </div>

        </form>
    </div>
</div>